// A-01 `?redirect=` and A-06 return paths: same-origin paths only, so a link can't send a signed-in user to another
// site (T-A06-02, T-SEC-25).

/** The path to go to after sign-in, or `/` when `redirect` is missing, absolute, protocol-relative or odd. */
export function safeRedirect(redirect: unknown): string {
  if (typeof redirect !== 'string' || redirect === '') return '/'
  if (!redirect.startsWith('/') || redirect.startsWith('//') || redirect.startsWith('/\\')) return '/'
  for (let i = 0; i < redirect.length; i++) {
    const code = redirect.charCodeAt(i)
    if (code < 0x20 || code === 0x7f) return '/'
  }
  try {
    const url = new URL(redirect, 'https://same.origin.invalid')
    if (url.origin !== 'https://same.origin.invalid') return '/'
    // Never back into the auth screens themselves.
    if (url.pathname === '/sign-in') return '/'
    return `${url.pathname}${url.search}${url.hash}`
  } catch {
    return '/'
  }
}

/** `/sign-in?reason=…&redirect=…` */
export function signInHref(
  options: { reason?: 'session-expired' | 'reauth' | 'clinic-inactive'; redirect?: string } = {},
): string {
  const params = new URLSearchParams()
  if (options.redirect && safeRedirect(options.redirect) !== '/') params.set('redirect', safeRedirect(options.redirect))
  if (options.reason) params.set('reason', options.reason)
  const query = params.toString()
  return query ? `/sign-in?${query}` : '/sign-in'
}
